export const StudentBookCardStyle = {
  cardContainer: 'flex flex-col grow p-4 w-full h-full bg-lightBlack rounded-[4px]',
  imageWrapper: 'flex justify-end pb-4',
  text: 'flex flex-col',
}
